export default __webpack_public_path__ + "static/introduction-cc2d54ade82f6ca15e1868ff351ee0d6.jpg";